const getValidDate = (date) => {
  const dateObj = date && new Date(date);
  return isNaN(Date.parse(dateObj)) ? null : dateObj;
};

export default getValidDate;
